export const inr = (n) => `\u20b9${Number(n || 0).toLocaleString("en-IN")}`;

export const timeFrom = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const scoreStr = (s) => {
  if (!s) return "";
  return `${s.runs}/${s.wickets} (${s.overs})`;
};

export const matchDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const matchTime = (iso) => {
  try {
    return new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
};
// Wallet header amounts: always 2 decimals, Indian grouping (₹30,550.33).
export const inr2 = (n) => `\u20b9${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
